import { BUTTON_TYPES } from 'src/models/register/RegisterButton'
import availabilitiesAndConstraintsService from 'src/services/inventory/sales-restrictions/AvailabilitiesAndConstraintsService'
import { getInventoryStrategy } from 'src/services/inventory/sales-restrictions/helpers'
import isOutOfStockService from 'src/services/inventory/sales-restrictions/IsOutOfStockService'

class HasReducedOpacityService {
  static #instance = null

  static #availabilitiesAndConstraintsService = null
  static #isOutOfStockService = null

  constructor ({
    availabilitiesAndConstraintsService,
    isOutOfStockService
  }) {
    if (!HasReducedOpacityService.#instance) {
      HasReducedOpacityService.#availabilitiesAndConstraintsService = availabilitiesAndConstraintsService
      HasReducedOpacityService.#isOutOfStockService = isOutOfStockService

      HasReducedOpacityService.#instance = this
    }
    return HasReducedOpacityService.#instance
  }

  hasReducedOpacity (model, options) {
    // Early return for non-item or item variation buttons
    if (model.typeName === 'RegisterButton' && model.type !== BUTTON_TYPES.ITEM && model.type !== BUTTON_TYPES.ITEM_VARIATION) return false

    // Early return for sales unavailable or disabled items
    if (model.areSalesRequirementsUnmet || model.salesDisabled) return true

    // Early return for non-inventoriable models
    if (!HasReducedOpacityService.#availabilitiesAndConstraintsService.isModelInventoriable(model)) return false

    const inventoryStrategy = getInventoryStrategy()

    // Early return when the inventory strategy has no inventory restriction type
    if (_.isNil(inventoryStrategy?.inventoryRestrictionType)) return false

    // Return true if the item is out of stock
    return HasReducedOpacityService.#isOutOfStockService.isOutOfStock(model, options)
  }
}

const hasReducedOpacityService = new HasReducedOpacityService({
  availabilitiesAndConstraintsService,
  isOutOfStockService
})

export default hasReducedOpacityService
